import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";
import type { User, UserRegistration } from "@/commons/types/api/schema.types";

export const sendProductTourStep = async (payload: UserRegistration) => {
  try {
    const response = await httpRequest("patch", "/users", {
      tour_step_viewed: payload,
    });
    return response.data;
  } catch (error) {
    handleNetworkError(error);
  }
};

/** Onboarding - alert: follow Feuille Verte and ODJ */
export const patchFollowFeuilleVerteOdj = async () => {
  try {
    const response = await httpRequest<User, never>(
      "patch",
      "/users/follaw-feuille-verte-odj"
    );
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
